import {
  TOGGLE_SEARCH,
  TOGGLE_SEARCH_FIELD,
  CHANGE_SEARCH_LOADING,
  CHANGE_SEARCH_LOADING_MORE,
  CHANGE_SEARCH_VALUE,
  CHANGE_SEARCH_FIELDS,
  CHANGE_SEARCH_RESULTS,
  CHANGE_SEARCH_PAGINATION
} from './actions'

export default function(state = {
  visible: false,
  loading: false,
  loadingMore: false,
  value: '',
  fields: [],
  results: [],
  pagination: {
    total: 0,
    from: 0,
    size: 15
  }
}, action) {
  switch(action.type) {
    case TOGGLE_SEARCH:
    return { ...state, visible: !state.visible }
    case TOGGLE_SEARCH_FIELD:
      let found = state.fields.some(field => {
        return field === action.payload
      })

      if (!found) {
        return {
          ...state, fields: [...state.fields, action.payload]
        }
      } else {
        return {
          ...state, fields: state.fields.filter(field => field !== action.payload)
        }
      }
    case CHANGE_SEARCH_LOADING:
    return { ...state, loading: action.payload }
    case CHANGE_SEARCH_LOADING_MORE:
      return { ...state, loadingMore: action.payload }
    case CHANGE_SEARCH_VALUE:
      return { ...state, value: action.payload }
    case CHANGE_SEARCH_FIELDS:
      return { ...state, fields: action.payload }
    case CHANGE_SEARCH_RESULTS:
      let from = action.payload.from
      let results =  action.payload.results

      if (from === 0) {
        return { ...state, results }
      } else {
        return { ...state, results: state.results.concat(results) }
      }
    case CHANGE_SEARCH_PAGINATION:
      return { ...state, pagination: action.payload  }
    default:
      return state
  }
}
